Drupal.behaviors.menu = {
  attach() {
    var navbarLinks = document.querySelectorAll('.navbar-primary a, .navbar-primary button');
    for (var i = 0; i < navbarLinks.length; i++) {
      var self = navbarLinks[i];
      self.addEventListener('click', function (event) {
        var targetValue = event.currentTarget.getAttribute("id");
        var subMenu = document.querySelector('.mainnav div[data-show="' + targetValue + '"]');
        subMenu.classList.toggle("hidden");
      });

      var closeIcon = document.querySelectorAll('.closeIcon')[0];
      closeIcon.addEventListener('click', function () {
        var subMenus = document.querySelectorAll('.subnav');
        for (var i = 0; i < subMenus.length; i++) {
          subMenus[i].classList.add("hidden");
        }
      });
    }

    reportWindowSize();

    window.addEventListener("resize", reportWindowSize);

    function reportWindowSize() {
      if (document.getElementsByClassName("toolbar").length > 0) {
        var width = window.innerWidth;
        if (width < 976) {
          var toolbarWidth = 0;
          var toolbarHeight = (document.getElementsByClassName("gin-secondary-toolbar")[0]).offsetHeight + (document.getElementById("gin-toolbar-bar")).offsetHeight;
        } else {
          var toolbarWidth = (document.getElementsByClassName("toolbar-menu")[0]).offsetWidth;
          var toolbarHeight = (document.getElementsByClassName("gin-secondary-toolbar")[0]).offsetHeight;

        }

        var subnavs = document.getElementsByClassName("subnav");
        var shims = document.getElementsByClassName("shim");
        if (shims.length > 0) {
          var shim = shims[0];
          shim.style.top = toolbarHeight + "px";
          shim.style.left = toolbarWidth + "px";
        }

        for (var i = 0; i < subnavs.length; i++) {
          subnavs[i].style.left = toolbarWidth + "px";
          subnavs[i].style.top = toolbarHeight + "px";
        }
      }
    }
  },
};
